<template>
  <div id="app">
    <router-view :key="$route.fullPath" v-if="isRouterAlive"/>
    <loading v-if="this.$store.state.isLoad"></loading>
    <div v-show="isShow" class="guide-wrap-app"></div>
  </div>
</template>

<script>
  import store from 'vuex'
  import loading from './components/loading.vue'
  export default {
    name: 'App',
    data(){
      return {
        isRouterAlive: true,
        isShow: true,
        downTimes: 1
      }
    },
    provide(){
      return {
        reload: this.reload
      }
    },
    mounted(){
      setInterval(()=>{
        this.downTimes --;
        if(this.downTimes == 0){
          this.isShow = false;
        }
      },1000)
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function(){
          this.isRouterAlive = true;
        })
      }
    },
    components: {
      loading
    },
  }
</script>
<style>
  .guide-wrap-app{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
	  background: url('../static/images/start.png') no-repeat center;
	  background-size: cover;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue